<template>
    <div>
        <div v-if="flagOrientation">
            <v-app>
                <v-main>
                    <router-view />
                </v-main>
            </v-app>
        </div>

        <NotLandskape
            v-if="!flagOrientation"
            h1="Поверните устройство"
            p="На мобильных устройствах приложение работает только в вертикальной ориентации."
        />
    </div>
</template>

<script>
import axios from 'axios'
import NotLandskape from '@/components/NotLandskape/index.vue'
import {mapActions, mapGetters} from 'vuex'

export default {
    components: {
        NotLandskape
    },
    data: () => ({
        flagOrientation: true
    }),
    computed: {
        ...mapGetters({
            apiUrl: 'apiUrl'
        })
    },
    methods: {
        ...mapActions({
            logout: 'login/logout',
        }),
        handle() {
            let breakpointName = this.$vuetify.breakpoint.name;

            console.log('handle', breakpointName, screen.orientation.type);
            if(breakpointName !== 'xs' && breakpointName !== 'sm') {
                this.flagOrientation = true;
                return;
            }

            switch (screen.orientation.type) {
                case "landscape-secondary":
                    this.flagOrientation = false;
                    break;
                case "landscape-primary":
                case "portrait-secondary":
                case "portrait-primary":
                    this.flagOrientation = true;
                    break;
                default:
                    this.flagOrientation = false;
                    break;
            }
        }
    },
    mounted() {
        window.addEventListener("orientationchange", this.handle);
    },
    destroyed() {
        window.removeEventListener('orientationchange', this.handle)
    },
    created() {
        this.handle();
        
        document.GLOBAL_PROCESS_FLAG = this.apiUrl === 'https://apivp.nitrosbase.com/';

        axios.interceptors.response.use(undefined, (err) => {
            return new Promise((resolve, reject) => { // eslint-disable-line
                if (err && err.response &&  err.response.status && err.response.status === 401) {
                this.logout()
                this.$router.push('/')
                }
                throw err;
            })
        })
    }
}
</script>

<style lang="scss">
@import "~@/scss/global.scss";
// .v-text-field__details {
//   display: none !important;
// }
</style>
